import { Injectable, resource, signal } from '@angular/core';
import { RestDatasource } from '@core/api/rest.datasource';
import { Bruger } from '@features/brugere/bruger.model';
import { BrugerSearchParams } from '@features/brugere/bruger-search-params.model';
import { BrugerRolleChangeModel } from './bruger-detail/bruger-detail.service';
import { appConfig } from '@core/app-config';

@Injectable({
  providedIn: 'root',
})
export class BrugerDatasource extends RestDatasource<Bruger> {
  override endpoint = '/v2/brugere';

  searchParams = signal<BrugerSearchParams>({ text: '' });

  data = resource({
    params: () => this.searchParams(),
    loader: async ({ params, abortSignal }) => {
      return await this.getList(
        {
          filter: JSON.stringify(params),
          sortBy: 'fornavn',
        },
        abortSignal
      );
    },
  });

  async saveBrugerAndRoller(
    bruger: Bruger,
    rolleChanges: Record<number, BrugerRolleChangeModel>,
    kommentar: string
  ) {
    const changes: BrugerRolleChangeModel[] = [];

    for (const [, value] of Object.entries(rolleChanges)) {
      changes.push(value);
    }

    const payload = {
      bruger: bruger,
      rolleChanges: changes,
      kommentar: kommentar,
    };

    const url = `${appConfig.apiRoot}${this.endpoint}/saveall`;
    const options = await this.getOptions();
    options.method = 'POST';
    options.body = JSON.stringify(payload);
    return await this.fetchSingle(url, options);
  }

  async recreateBruger(bruger: Bruger) {
    const url = `${appConfig.apiRoot}${this.endpoint}/recreate`;
    const options = await this.getOptions();
    options.method = 'POST';
    options.body = JSON.stringify(bruger);
    return await this.fetchSingle(url, options);
  }
}
